// ANGULAR
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

// APP
import { EntryProcessFormRoutingModule } from './entry-process-form-routing.module';
import { EntryProcessFormComponent } from './entry-process-form.component';

// MODULE
import { AppSharedModule } from 'src/app/app-shared/app-shared.module';
import { WHButtonComponent } from 'src/app/app-shared/components/buttons/w-h-button/w-h-button.component';
import { WHButtonGroupComponent } from 'src/app/app-shared/components/buttons/w-h-button-group/w-h-button-group.component';

@NgModule({
  declarations: [EntryProcessFormComponent],
  exports: [EntryProcessFormComponent],
  imports: [
    WHButtonComponent,
    WHButtonGroupComponent,
    ReactiveFormsModule,
    AppSharedModule,
    EntryProcessFormRoutingModule,
  ],
})
export class EntryProcessFormModule {}
